import {GetConsultProtocols} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetConsultProtocols} from 'data/usecases';
import {consultProtocolsFlowEndpoints} from '../../endpoints';

export const makeGetConsultProtocols = (): GetConsultProtocols =>
	new RemoteGetConsultProtocols(
		makeBFFApiUrl(consultProtocolsFlowEndpoints.consultProtocols),
		makeAuthorizeHttpClientDecorator(),
	);
